module.exports = __webpack_public_path__ + "img/123123123.75a00777.png";